"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _createSvg = require("../createSvg");
var _interfaces = require("../interfaces");
var _SVGIconWithSizes;
var _default = (0, _createSvg.createSvg)('IconBold', new _interfaces.SVGIconWithSizes((_SVGIconWithSizes = {}, (0, _defineProperty2.default)(_SVGIconWithSizes, _interfaces.IconSize.ExtraSmall, {
  paths: ['M10.0634 7.63877C11.1143 7.24826 12.0039 6.43794 12.0039 4.74895C12.0039 1.39052 8.58036 1 7.775 1L2 1L2 15H8.07946C10.0045 15 13 13.8879 13 11.2031C13 8.7624 11.1732 7.79498 10.0634 7.64854V7.63877ZM5 3H7C8 3 9 3.5 9 5C9 6.5 8 7 7 7H5V3ZM8 13H5V9H8C9 9 10 9.5 10 11C10 12.5 9 13 8 13Z'],
  params: {
    height: '16',
    xmlns: 'http://www.w3.org/2000/svg'
  },
  height: 16,
  width: 16
}), (0, _defineProperty2.default)(_SVGIconWithSizes, _interfaces.IconSize.Small, {
  paths: ['M12.2625 9.53556C13.6 9.03347 14.7322 7.99163 14.7322 5.82008C14.7322 1.50209 10.375 1 9.35 1L2 1L2 19H9.7375C12.1875 19 16 17.5702 16 14.1183C16 10.9802 13.675 9.7364 12.2625 9.54812V9.53556ZM6.00391 3.57143L8.36364 3.57143C9.63636 3.57143 11 4.21429 11 6.14286C11 8.07143 9.63636 8.71429 8.36364 8.71429L6.00391 8.71429V3.57143ZM9.63636 16.4286L6.00391 16.4286V11.2857L9.63636 11.2857C10.9091 11.2857 12.4688 11.9286 12.4688 13.8571C12.4688 15.7857 10.9091 16.4286 9.63636 16.4286Z'],
  params: {
    height: '20',
    xmlns: 'http://www.w3.org/2000/svg'
  },
  height: 20,
  width: 20
}), (0, _defineProperty2.default)(_SVGIconWithSizes, _interfaces.IconSize.Medium, {
  paths: ['M15.4616 11.4324C17.0857 10.8187 18.4606 9.54533 18.4606 6.89121C18.4606 1.61367 13.1696 1 11.925 1L3 1L3 23H12.3955C15.3705 23 20 21.2524 20 17.0335C20 13.1981 17.1768 11.6778 15.4616 11.4477V11.4324ZM8 4H10.7273C12.2727 4 14 4.92411 14 7.28125C14 9.63839 12.2727 10.4286 10.7273 10.4286L8 10.4286V4ZM12.2727 19.8571L8 19.8571V13.5714L12.2727 13.5714C13.8182 13.5714 15.7121 14.3571 15.7121 16.7143C15.7121 19.0714 13.8182 19.8571 12.2727 19.8571Z'],
  params: {
    height: '24',
    xmlns: 'http://www.w3.org/2000/svg'
  },
  height: 24,
  width: 24
}), (0, _defineProperty2.default)(_SVGIconWithSizes, _interfaces.IconSize.Large, {
  paths: ['M20.8598 15.2259C23.0571 14.3891 24.9173 12.6527 24.9173 9.03347C24.9173 1.83682 17.7589 1 16.075 1L4 1L4 31H16.7116C20.7366 31 27 28.617 27 22.8638C27 17.6337 23.1804 15.5607 20.8598 15.2469V15.2259ZM11 5.09091H14.4545C16.5455 5.09091 19 6.35106 19 9.56534C19 12.7796 16.5455 13.8571 14.4545 13.8571L11 13.8571V5.09091ZM16.5455 26.7143L11 26.7143V18.1429L16.5455 18.1429C18.6364 18.1429 21 19.2143 21 22.4286C21 25.6429 18.6364 26.7143 16.5455 26.7143Z'],
  params: {
    height: '32',
    xmlns: 'http://www.w3.org/2000/svg'
  },
  height: 32,
  width: 32
}), _SVGIconWithSizes)));
exports.default = _default;